import { useUserPermissions } from "@/hooks";
import { ReactNode } from "react";

interface HasAppPermissionProps {
  children: ReactNode;
  requiredPermissions: string[];
}

const HasAnyPermission = ({ children, requiredPermissions }: Readonly<HasAppPermissionProps>) => {
  const { hasAnyPermission } = useUserPermissions();

  if (!hasAnyPermission(requiredPermissions)) {
    return null;
  }

  return children;
};

export default HasAnyPermission;
